// @flow

/**
 * Export `setBodyOverflow`.
 */

export function setBodyOverflow(state: boolean) {
  // $FlowFixMe
  document.body.style.overflow = state ? 'hidden' : '';
}



// WEBPACK FOOTER //
// ../src/client/core/utils/body.js